import React, { useContext, ReactElement } from 'react';
import { Box } from '@wds/box';
import { PageVariants, EnterpriseThankYouContext } from '~app/pages/EnterpriseThankYou';
import useStyles from './useStyles';

type Props = React.PropsWithChildren<{}>;

function EnterpriseThankYouLayout({ children }: Props): ReactElement {
  const { pageVariant } = useContext(EnterpriseThankYouContext);
  const { container } = useStyles({
    isPremiumCustom: pageVariant === PageVariants.premiumCustom,
  });

  return <Box className={container}>{children}</Box>;
}

export default EnterpriseThankYouLayout;
